/* ============================================================
   Cart Upsell - Jerseys.co.il
   v2: Modal removed. Drawer-rail powered.
   Responsibilities:
   - Maintain team-specific complement map (scarf + ball)
   - On jersey-add, prepend complement products to window.__CART_UPSELLS__
     and dispatch 'cart:upsells-updated' for cart-drawer.js to re-render
     the in-drawer horizontal carousel (no modal)
   - Product-page cross-sell row (#cup-page-recs) - UNCHANGED
   ============================================================ */
(function () {
  'use strict';

  var FALLBACK_BALL = 'כדור-כדורגל-מונדיאל-2026';

  /* Mirrored in ../complements-map.json, which build-bundle-recommendations.mjs
     reads for the rules layer of the PDP bundle widget. A team added in one
     place must be added in the other - this copy serves the drawer at runtime,
     that one is read at build time and cannot import from here. */
  var COMPLEMENTS = {
    'real-madrid':        { scarf: 'real-madrid-football-scarf',        ball: 'כדור-כדורגל-ריאל-מדריד' },
    'barcelona':          { scarf: 'barcelona-football-scarf',           ball: 'כדור-כדורגל-ברצלונה' },
    'liverpool':          { scarf: 'liverpool-football-scarf',           ball: 'כדור-כדורגל-ליברפול' },
    'manchester-united':  { scarf: 'manchester-united-football-scarf',   ball: 'כדור-כדורגל-מנצסטר-יונייטד' },
    'psg':                { scarf: 'psg-football-scarf',                 ball: 'כדור-כדורגל-פריז-סן-זרמן' },
    'juventus':           { scarf: 'juventus-football-scarf',            ball: 'כדור-כדורגל-יובנטוס' },
    'chelsea':            { scarf: 'chelsea-football-scarf',             ball: null },
    'arsenal':            { scarf: 'arsenal-football-scarf',             ball: null },
    'manchester-city':    { scarf: 'manchester-city-football-scarf',     ball: null },
    'tottenham-hotspur':  { scarf: 'tottenham-football-scarf',           ball: null },
    'atletico-madrid':    { scarf: 'atletico-madrid-football-scarf',     ball: null },
    'ac-milan':           { scarf: 'ac-milan-football-scarf',            ball: null },
    'inter-milan':        { scarf: 'inter-milan-football-scarf',         ball: null },
    'borussia-dortmund':  { scarf: 'borussia-dortmund-football-scarf',   ball: null },
    'bayern-munich':      { scarf: 'bayern-munich-football-scarf',       ball: null },
    'argentina':          { scarf: 'argentina-football-scarf',           ball: null },
    'spain':              { scarf: 'spain-football-scarf',               ball: null },
    'brazil':             { scarf: 'brazil-football-scarf',              ball: null },
    'france':             { scarf: 'france-football-scarf',              ball: null },
    'germany':            { scarf: 'germany-football-scarf',             ball: null },
    'portugal':           { scarf: 'portugal-football-scarf',            ball: null },
    'netherlands':        { scarf: 'netherlands-football-scarf',         ball: null },
    'cristiano-ronaldo':  { scarf: 'portugal-football-scarf',            ball: 'כדור-כדורגל-כריסטיאנו-רונאלדו' },
    'lionel-messi':       { scarf: 'argentina-football-scarf',           ball: null },
    'kylian-mbappe':      { scarf: 'france-football-scarf',              ball: null },
    'lamine-yamal':       { scarf: 'spain-football-scarf',               ball: null },
    'neymar-jr':          { scarf: 'brazil-football-scarf',              ball: null },
    'bruno-fernandes':    { scarf: 'portugal-football-scarf',            ball: null },
    'raphinha':           { scarf: 'brazil-football-scarf',              ball: null },
    'erling-haaland':     { scarf: null,                                  ball: null },
    'jude-bellingham':    { scarf: null,                                  ball: null }
  };

  var JERSEY_COLLECTIONS = (function () {
    var t = {};
    ['football-shirts-men','kids-football-kits','retro-football-shirts',
     'national-teams-football-shirts','kids-retro-football-kits',
     'football-jacket-kits','football-hoodie-kits','football-half-zip-tracksuits',
     'winter-apparel','premier-league','la-liga','serie-a','bundesliga',
     'ligue-1','mls','season-2025-26','season-2024-25','season-2023-24',
     'world-cup-2026','world-cup-2022','euro-copa-america-2024','shop-by-player',
     'best-sellers','world-leagues-shirts'].forEach(function (h) { t[h] = true; });
    Object.keys(COMPLEMENTS).forEach(function (h) { t[h] = true; });
    return t;
  }());

  /* ---------- Helpers ---------- */
  function imgSrc(url, w) {
    if (!url) return '';
    return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/, '_' + w + 'x$1');
  }
  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) {
      if (!r.ok) throw new Error('404: ' + handle);
      return r.json();
    });
  }
  function isJerseyProduct(cols) {
    for (var i = 0; i < cols.length; i++) { if (JERSEY_COLLECTIONS[cols[i]]) return true; }
    return false;
  }
  function findComplement(cols) {
    for (var i = 0; i < cols.length; i++) { if (COMPLEMENTS[cols[i]]) return COMPLEMENTS[cols[i]]; }
    return null;
  }
  function savings(v) {
    return (v.compare_at_price && v.compare_at_price > v.price)
      ? Math.round((v.compare_at_price - v.price) / 100) : 0;
  }

  /* ---------- Convert /products/:handle.js JSON → __CART_UPSELLS__ entry ---------- */
  function toUpsellEntry(product) {
    if (!product) return null;
    var v = product.variants && product.variants[0];
    if (!v) return null;
    return {
      id: product.id,
      title: product.title,
      handle: product.handle,
      price: v.price,
      compare_at_price: v.compare_at_price || 0,
      image: imgSrc(product.featured_image || '', 160),
      url: '/products/' + product.handle,
      variant_id: v.id,
      available: !!v.available
    };
  }

  /* ---------- Promote complement products to front of __CART_UPSELLS__ ---------- */
  function promoteComplements(complementProducts) {
    var existing = Array.isArray(window.__CART_UPSELLS__) ? window.__CART_UPSELLS__ : [];
    var promotedIds = {};
    var promoted = [];
    complementProducts.forEach(function (p) {
      var entry = toUpsellEntry(p);
      if (entry && entry.available && !promotedIds[entry.id]) {
        // Flag team-complement matches so the drawer rail can lead with them
        // (the 1-2 prominent hero cards) ahead of the generic cart-upsells.
        entry.is_complement = true;
        promotedIds[entry.id] = true;
        promoted.push(entry);
      }
    });
    var rest = existing.filter(function (u) { return !promotedIds[u.id]; });
    window.__CART_UPSELLS__ = promoted.concat(rest);
    document.dispatchEvent(new CustomEvent('cart:upsells-updated', {
      detail: { source: 'complement', count: promoted.length }
    }));
  }

  /* ---------- Trigger on jersey add ---------- */
  function handleJerseyAdded(collections) {
    var complement  = findComplement(collections);
    var scarfHandle = complement ? complement.scarf : null;
    var ballHandle  = complement ? (complement.ball || FALLBACK_BALL) : FALLBACK_BALL;

    var promises = [
      scarfHandle ? fetchProduct(scarfHandle).catch(function () { return null; }) : Promise.resolve(null),
      ballHandle  ? fetchProduct(ballHandle ).catch(function () { return null; }) : Promise.resolve(null)
    ];
    Promise.all(promises).then(function (r) {
      var products = r.filter(Boolean);
      if (!products.length) return;
      promoteComplements(products);
    }).catch(function (e) { console.warn('[upsell]', e); });
  }

  document.addEventListener('cart:jersey-added', function (e) {
    var cols = (e.detail && e.detail.collections) ? e.detail.collections : [];
    if (!isJerseyProduct(cols)) return;
    handleJerseyAdded(cols);
  });

  /* ==========================================================
     PRODUCT PAGE CROSS-SELL ROW (untouched)
     ========================================================== */
  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function price(cents) { return '₪' + Math.round(cents / 100); }

  function buildPageCard(product, label) {
    var v   = product.variants[0];
    var img = product.featured_image || '';
    var saved = savings(v);
    var card = document.createElement('a');
    card.href = '/products/' + product.handle;
    card.className = 'cup-page-card';
    card.innerHTML =
      '<div class="cup-page-card__inner">' +
        '<span class="cup-page-card__label">' + esc(label) + '</span>' +
        (saved ? '<span class="cup-page-card__save">חסוך ₪' + saved + '</span>' : '') +
        '<div class="cup-page-card__img">' +
          (img ? '<img src="' + esc(imgSrc(img, 200)) + '" alt="' + esc(product.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<p class="cup-page-card__name">' + esc(product.title) + '</p>' +
        '<p class="cup-page-card__price">' +
          (v.compare_at_price && v.compare_at_price > v.price
            ? '<s>' + price(v.compare_at_price) + '</s> ' : '') +
          price(v.price) +
        '</p>' +
      '</div>';
    return card;
  }

  function initPageRecs() {
    var container = document.getElementById('cup-page-recs');
    if (!container) return;

    var cols = window.__CUP_COLS__ || [];
    if (!cols.length) return;

    var complement  = findComplement(cols);
    if (!complement && !isJerseyProduct(cols)) return;

    var scarfHandle = complement ? complement.scarf : null;
    var ballHandle  = complement ? (complement.ball || FALLBACK_BALL) : FALLBACK_BALL;

    if (!scarfHandle && !ballHandle) return;

    var promises = [
      scarfHandle ? fetchProduct(scarfHandle).catch(function () { return null; }) : Promise.resolve(null),
      ballHandle  ? fetchProduct(ballHandle).catch(function () { return null; })  : Promise.resolve(null)
    ];

    Promise.all(promises).then(function (r) {
      var scarf = r[0], ball = r[1];
      if (!scarf && !ball) return;

      container.innerHTML =
        '<div class="cup-page-recs__head">' +
          '<h2 class="cup-page-recs__title">לקוחות שקנו חולצת כדורגל זו גם קנו</h2>' +
          '<span class="cup-page-recs__badge">' + ((window.JERSEYS_FLASH && window.JERSEYS_FLASH.active) ? window.JERSEYS_FLASH.badge : ((window.JERSEYS_CART && window.JERSEYS_CART.promoQty) || 3) + '+1 זמין') + '</span>' +
        '</div>' +
        '<div class="cup-page-recs__row" id="cup-page-recs-row"></div>';

      var row = container.querySelector('#cup-page-recs-row');
      if (scarf) row.appendChild(buildPageCard(scarf, 'צעיף'));
      if (ball)  row.appendChild(buildPageCard(ball, 'כדור'));

      container.removeAttribute('hidden');
    }).catch(function (e) { console.warn('[page-recs]', e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageRecs);
  } else {
    setTimeout(initPageRecs, 0);
  }
}());
